<template>
   <div class="quetation">
       <div class="opera-group">
           <a-button type="primary" @click="addItem">项目挂牌</a-button>
       </div>  
       <div class="manage-table">
           <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" :scroll="{ x: 1260 }"   :rowKey="(record,index)=>{return index}" >
               <span slot="projectCode" slot-scope="text">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ text }}</span>
                     </template>
                     {{ text }}
                  </a-tooltip>
               </span>
               <span slot="projectName" slot-scope="text">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ text }}</span>
                     </template>
                     {{ text }}
                  </a-tooltip>
               </span>
               <span slot="quotationType" slot-scope="text">{{ text=='0'?'信用挂牌':'流转保证金挂牌' }}</span>
               <span slot="analysisState" slot-scope="text">{{ text=='0'?'未分析':'已分析' }}</span>
               <span slot="listedState" slot-scope="text">
                  {{ text=='0'?'已挂单':text=='1'?'已摘单':text=='2'?'已成交':'已撤单' }}
               </span>
               <span slot="quotationPrice" slot-scope="text">
                  {{ text }}万元
               </span>
               <span slot="auditState" slot-scope="text">
                  {{ text=='0'?'待支付':text=='1'?'待审核':text=='2'?'已通过':'未通过' }}
               </span>
               <span slot="entrustTime" slot-scope="text">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ text }}</span>
                     </template>
                     {{ text }}
                  </a-tooltip>
               </span>   
               <template slot="action" slot-scope="text,record">
                  <div class="operate-btns">
                     <a-button type="primary" @click="forDetail(record)">查看详情</a-button>
                     <a-upload class="upload-demo"
                           action="#" :customRequest="customRequest" :show-upload-list="false"
                           @click.native = getRow(record)
                           >
                     <a-button type="primary" :disabled="record.paymentUrl?true:false || record.quotationType=='0'?true:false">上传流转保证金凭证</a-button>
                     </a-upload>

                     <a-button type="primary" :disabled="record.auditState=='2'?true:false" @click="calcel(record)" >取消</a-button>
                  </div>
               </template>
           </a-table>
       </div>   
       <dialog-manage ref="addItem" @getDataList="getDataPage"></dialog-manage>
       <detail ref="detail"></detail>
       <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination>
   </div>    
</template>

<script>
import dialogManage from './dialog.vue'
import detail from './detail.vue'
const columns = [
   {
      title: '项目编码',
      dataIndex: 'projectCode',
      width: 100,
      scopedSlots: { customRender: 'projectCode' },
   },
   {
      title: '项目名称',
      dataIndex: 'projectName',
      width: 100,
      scopedSlots: { customRender: 'projectName' },
   },
   {
      title: '挂牌价',
      dataIndex: 'quotationPrice',
      width: 100,
      scopedSlots: { customRender: 'quotationPrice' },
   },
   {
      title: '挂牌类型',
      dataIndex: 'quotationType',
      width: 100,
      scopedSlots: { customRender: 'quotationType' },
   },
   {
      title: '项目分析状态',
      dataIndex: 'analysisState',
      width: 100,
      scopedSlots: { customRender: 'analysisState' },
   },
   {
      title: '挂单状态',
      dataIndex: 'listedState',
      width: 100,
      scopedSlots: { customRender: 'listedState' },
   },
   {
      title: '审核状态',
      dataIndex: 'auditState',
      width: 100,
      scopedSlots: { customRender: 'auditState' },
   },
   {
      title: '委托时间',
      dataIndex: 'entrustTime',
      width: 150,
      scopedSlots: { customRender: 'entrustTime' },
   },
   {
      title: '操作',
      fixed: 'right',
      id:'8',
      dataIndex: 'operate',
      width: 360,
      scopedSlots: { customRender: 'action' },
   },
];
export default {
    components:{
        dialogManage,
        detail
    },
    data(){
        return{
            columns:columns,
            data:[],
            projectDict:[
               {
                   bg_project_category:[]
               }
            ],
            total:1,
            params:{
              pageSize:10,
              pageNum:1
            },
            loading:false,
            currentId:'',
        }
    },
    created(){
        this.$parent.activeIndex = 2;
        this.getDataList();
    },
    methods:{
        addItem(row){
          this.$refs.addItem.showDiolag(row);
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
        getDataPage(){
            this.params.pageNum = 1;
            this.getDataList();
        },
        getRow(row){
           this.currentId = row.id;
           console.log(this.currentId)
        },
        customRequest(info){
           let formdata=new FormData();
            formdata.append("file",info.file);
            this.$https.post('/file/upload',formdata).then(res=>{
               if(res.code == 200){
                  this.uploadNote(res.data.url)
               }
            }).catch(error=>{
               this.$error({content:'上传失败'});
            })
        },
        uploadNote(url){
            this.$https.post('/portal/listing/uploadMarginNote',{paymentUrl:url,id:this.currentId}).then(res=>{
                   if(res.code == 200){
                      this.$message.success('上传成功');
                      this.getDataPage();
                   }
            })
        },
        getDataList(){
            this.loading = true;
            this.$https.get('/portal/listing/projectQuotationList',{params:this.params}).then(res=>{
               this.loading = false;
               if(res.code == 200){
                  this.data = res.rows;
                  this.total = Number(res.total);
               }
            }).catch(error=>{
                this.loading = false;
            })
        },
        forDetail(row){
            row = JSON.stringify(row)
            this.$refs.detail.showDiolag(row,2)
        },
        calcel(row){
         let _this = this;
         this.$confirm({
               title: '确定取消该挂牌?',
               content: '',
               onOk() {
                  _this.$https.post(`/portal/listing/cancleQuotation/${row.id}`).then(res=>{
                        if(res.code == 200){
                           _this.$message.success('取消成功');
                           _this.getDataPage();
                        }
                  }).catch(error=>{
                           _this.$message.success('取消失败');
                  })
               },
               onCancel() {},
               });
        }
    }
}
</script>

<style lang="less" scoped>
.opera-group{
   margin:0 0 20px 20px;
}
.operate-btns{
   display: flex;
   .ant-btn{
      margin-right:8px;
   }
}
</style>